export default "__VITE_ASSET__1a0e8290__"